import React from 'react';

const LoadingScreen: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-white bg-opacity-90 flex flex-col items-center justify-center z-50">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand mb-4"></div>
      <h2 className="text-xl font-semibold text-slate-700">Analyzing Report</h2>
      <p className="text-slate-500">Please wait while our AI generates a summary...</p>
    </div>
  );
};

export default LoadingScreen;